import { addFavorite, deleteFavorite } from "../http/favoriteApi";
import {
  mindboxAddToWishList,
  mindboxRemoveFromWishList,
} from "../http/catalogApi";

export function getMindboxDeviceUUID() {
  return document.cookie.replace(
    /(?:(?:^|.*;\s*)mindboxDeviceUUID\s*=\s*([^;]*).*$)|^.*$/,
    "$1"
  );
}

export function addOrRemoveFromFavorites(
  itemProduct,
  {
    user,
    currentFavorites = [],
    updateFavorites = () => {},
    onAddInFavorite = () => {},
  }
) {
  const deviceUUID = getMindboxDeviceUUID();
  const userAgent = window.navigator.userAgent;

  let currentFavoriteArray = [...currentFavorites];
  let index = currentFavoriteArray.findIndex((p) => p.id === itemProduct.id);
  const sizeId =
    itemProduct.child_product_size?.[0]?.id ??
    itemProduct.child_product_size_field?.[0]?.sizeId ??
    null;

  const currentSize = itemProduct.child_product_size?.find(
    (item) => item.id === sizeId
  );

  const guid = currentSize?.childProduct_Size?.guid ?? itemProduct.id;

  const price = itemProduct.parrent_price;

  if (index !== -1) {
    currentFavoriteArray.splice(index, 1);
    if (user?.user?.id) deleteFavorite(itemProduct.id, user.user.id);
    mindboxRemoveFromWishList(deviceUUID, userAgent, guid, price);
  } else {
    currentFavoriteArray.push(itemProduct);
    if (user?.isAuth) addFavorite(itemProduct.id, user.user.id);
    onAddInFavorite();
    mindboxAddToWishList(deviceUUID, userAgent, guid, price);
  }

  localStorage.setItem("favoriteStorage", JSON.stringify(currentFavoriteArray));
  updateFavorites(currentFavoriteArray);
}
